module.exports = __webpack_public_path__ + "static/images/opportunities.e1e5d91669443b5341f2411aa169f27c.svg";